import type { CallsignSchedulePeriod } from '@transreport/pauk-rrms-api'
import { format } from 'date-fns'

const CALLSIGN_COLOURS = [
  'border-brand bg-brand-surface text-brand-ink hover:bg-brand-surface-strong',
  'border-emerald-300 bg-emerald-100 text-emerald-950 hover:bg-emerald-200',
  'border-violet-300 bg-violet-100 text-violet-950 hover:bg-violet-200',
  'border-rose-300 bg-rose-100 text-rose-950 hover:bg-rose-200',
  'border-cyan-300 bg-cyan-100 text-cyan-950 hover:bg-cyan-200',
  'border-orange-300 bg-orange-100 text-orange-950 hover:bg-orange-200',
  'border-fuchsia-300 bg-fuchsia-100 text-fuchsia-950 hover:bg-fuchsia-200',
  'border-lime-300 bg-lime-100 text-lime-950 hover:bg-lime-200',
] as const

export function getCallsignColourClass(callsign: string): (typeof CALLSIGN_COLOURS)[number] {
  let hash = 0
  for (const character of callsign.trim().toLowerCase()) {
    hash = (hash * 31 + character.charCodeAt(0)) >>> 0
  }

  return CALLSIGN_COLOURS[hash % CALLSIGN_COLOURS.length]
}

function periodAppliesOnDate(period: CallsignSchedulePeriod, date: Date): boolean {
  const applicability = period.applicability ?? period.schedule.applicability ?? 'all_days'
  if (applicability === 'all_days') return true

  const isWeekend = date.getDay() === 0 || date.getDay() === 6
  return applicability === 'weekends' ? isWeekend : !isWeekend
}

export function getEffectivePeriodForDate(
  periods: CallsignSchedulePeriod[],
  date: Date
): CallsignSchedulePeriod | undefined {
  const dateKey = format(date, 'yyyy-MM-dd')
  return periods.find(
    (period) =>
      period.active_from <= dateKey &&
      dateKey < period.active_until &&
      periodAppliesOnDate(period, date)
  )
}
